import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/plugins/i18n'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './plugins/socket'

Vue.config.productionTip = false

const vue = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (store.state.user.current) {
  i18n.locale = store.state.user.current.lang
  vue.$vuetify.lang.current = store.state.user.current.lang
}

export default vue